import {Injectable, Type} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class ScheduleTypeService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/as/scheduleTypes');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        // if (mode != MvsCrudModeEnum.create) {
        //     return null;
        // }

        return null;
    }

}
